 
    $( "#form-newsletter" ).submit(function(submit){

        submit.preventDefault();
        //On recupère les différents message dont on a besoin
        var msgErreur = $(this).data('erreur');
        var msgRequired = $(this).data('required');
        var urlRequette = $(this).data('url');
        var form = $(this); // On récupère le formulaire actuel

        //On recupere les données du formulaire
        var email = $(this).find('input[name="email"]').val();
        var rgpd = $(this).find('input[name="footerNewsletterRGPD"]').prop( "checked" );

        //On masque les eventuels message d'erreur / succes
        $(this).find(".message-newsletter").remove();

        var siteKey = $(this).data('key');

        //Si les données sont bien renseigné"s
        if(email && rgpd){            
            
            //On prépare la requette ajax
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: 'inscription_newsletter' }).then(function (token) {

                    var request = $.ajax({
                        url: urlRequette+"/controller/markal/newsletter",
                        method: "POST",
                        data: { 
                            email : email,
                            rgpd : rgpd,
                            recaptcha_response : token,
                        },
                    });

                    //Si la requette est bien exécutée
                    request.done(function( msg ) {

                        //On récupere les données retournées par le controlleur et on les décode
                        if(msg){
                            msg = JSON.parse(msg);
                            // On récupère les trads selon les codes
                            messageErreur = form.data(msg.erreur);
                            messageSucces = form.data(msg.succes);
                            //Si erreur
                            if(msg.erreur){
                                $( "#form-newsletter" ).prepend("<div class='col-lg-12 message-newsletter'><div class='alert alert-danger'>"+messageErreur+"</div></div>");
                            }

                            //Si succes
                            if(msg.succes){
                                $( "#form-newsletter" ).prepend("<div class='col-lg-12 message-newsletter'><div class='alert alert-success'>"+messageSucces+"</div></div>");

                                //On vide les champs
                                $(this).find('input[name="email"]').val('')
                                $(this).find('input[name="footerNewsletterRGPD"]').prop( "checked", false );

                            }
                        }
                    });
                
                    //Si erreur
                    request.fail(function( jqXHR, textStatus ) {
                        //
                        $( "#form-newsletter" ).prepend("<div class='col-lg-12 message-newsletter'><div class='alert alert-danger'>"+msgErreur+"</div></div>");
                    });
                });
            })

        }else{
            //erreur champ mal renseigné
            $( "#form-newsletter" ).prepend("<div class='col-lg-12 message-newsletter'><div class='alert alert-danger'>"+msgRequired+"</div></div>");
        }

        return false;
    });
    